__turbopack_context__.v({
  "captionopen": "tkiteG_captionopen",
  "context": "tkiteG_context",
  "explanatory": "tkiteG_explanatory",
  "giveButtonWrapper": "tkiteG_giveButtonWrapper",
  "grid": "tkiteG_grid",
  "header": "tkiteG_header",
  "innerParagraphNumber": "tkiteG_innerParagraphNumber",
  "input": "tkiteG_input",
  "inputWrapper": "tkiteG_inputWrapper",
  "output": "tkiteG_output",
  "paragraphNumber": "tkiteG_paragraphNumber",
  "paragraphWrapper": "tkiteG_paragraphWrapper",
  "select": "tkiteG_select",
  "selected": "tkiteG_selected",
  "spinnerWrapper": "tkiteG_spinnerWrapper",
  "wrapper": "tkiteG_wrapper",
});
